'use client'

import Slider from '@/components/ui/Slider'
import { useSearchParams, useRouter, usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useFilterStore } from '@/store/useFilterStore'

interface SliderControlledProps {
    initialRange: { minPrice: number; maxPrice: number }
    categoryId: string
}

const SliderControlled = ({ initialRange }: SliderControlledProps) => {
    if (
        !initialRange ||
        typeof initialRange.minPrice !== 'number' ||
        typeof initialRange.maxPrice !== 'number' ||
        Number.isNaN(initialRange.minPrice) ||
        Number.isNaN(initialRange.maxPrice)
    ) {
        return 
    }

    const router = useRouter()
    const pathname = usePathname()
    const searchParams = useSearchParams()

    const priceMin = useFilterStore((s) => s.priceMin ?? initialRange.minPrice)
    const priceMax = useFilterStore((s) => s.priceMax ?? initialRange.maxPrice)
    const setPrice = useFilterStore((s) => s.setPrice)!


    const [local, setLocal] = useState<[number, number]>([priceMin, priceMax])

    useEffect(() => {
        const urlMin =
            Number(searchParams.get('minPrice')) || initialRange.minPrice
        const urlMax =
            Number(searchParams.get('maxPrice')) || initialRange.maxPrice


        setPrice(urlMin, urlMax)
        setLocal([urlMin, urlMax])
        // updateUrl(urlMin, urlMax)
    }, [initialRange.minPrice, initialRange.maxPrice])

    const updateUrl = (min: number, max: number) => {
        const params = new URLSearchParams(searchParams.toString())
        params.set('minPrice', String(min))
        params.set('maxPrice', String(max))
        params.delete('page')
        router.replace(`${pathname}?${params.toString()}`, { scroll: false })
    }

    const handleChange = (value: [number, number]) => {
        setLocal(value)
    }

    const handleChangeCommitted = (value: [number, number]) => {
        setPrice(value[0], value[1])
        updateUrl(value[0], value[1])
    }

    return (
        <div className="flex flex-col gap-5">
            <div className="my-5">
                <Slider.Range
                    value={local}
                    onChange={handleChange}
                    onDraggingStop={handleChangeCommitted}
                    min={initialRange.minPrice}
                    max={initialRange.maxPrice}
                    step={100}
                    classNames={{
                        bar: 'bg-second-light',
                        mark: 'bg-second-light',
                        thumb: [
                            'border-second-light bg-second-light',
                            'border-second-light bg-second-light',
                        ],
                    }}
                />
                <div className="mt-2 flex justify-between">
                    <strong>{local[0]}</strong> - <strong>{local[1]}</strong>
                </div>
            </div>
        </div>
    )
}

export default SliderControlled
